<template>
  <div class="vx-row">
    <div class="w-full vx-col">

      <vx-card :title="'RAW MATERIAL CODES'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-raw-material-codes-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="production-code-list-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="production_codes">
              <template slot="thead">
                <vs-th width="25%">PREFIX</vs-th>
                <vs-th width="50%">DESCRIPTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].prefix">
                    {{ data[indextr].prefix }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>


                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <create-raw-material-code-pop-up ref="createRawMaterialCodePopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import CreateRawMaterialCodePopUp from "@/components/popups/settings/raw-material-codes/CreateRawMaterialCodePopUp";

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial');

  export default {
    name: "ProductionCodesSettings",
    data() {
      return {
        production_codes: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      CreateRawMaterialCodePopUp,
    },
    methods: {
      async refreshData() {
        await this.fetchRawMaterialCodeLIst()
      },
      async fetchRawMaterialCodeLIst() {
        await this.$vs.loading({
          container: '#production-code-list-table',
          scale: 0.45
        })
        const {data} = await SupplierRawMaterialRepository.fetchRawMaterialCodes()
        this.production_codes =  data.data
        this.$vs.loading.close('#production-code-list-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.createRawMaterialCodePopUp.openPopup()
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      filterQueryUpdate (){
        this.fetchRawMaterialCodeLIst()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchRawMaterialCodeLIst()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRawMaterialCodeLIst()
        }
      },
    },
    async mounted() {
      await this.fetchRawMaterialCodeLIst()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchRawMaterialCodeLIst()
      },
      perPage() {
        this.fetchRawMaterialCodeLIst()
      }
    }
  }
</script>

<style scoped>

</style>
